export const graphConstants = {
    GET_GENERIC_GRAPHS_REQUEST: 'GET_GENERIC_GRAPHS_REQUEST',
    GET_GENERIC_GRAPHS_SUCCESS: 'GET_GENERIC_GRAPHS_SUCCESS',
    GET_GENERIC_GRAPHS_FAILURE: 'GET_GENERIC_GRAPHS_FAILURE',
  }